<template>
	<v-container>
		<v-row justify="center" class="secondary--text title my-2">
			{{'Contacts' | localize }}
		</v-row>
		<div v-if="!loading">
			<v-container>
				<v-row justify="center" class="my-8">
					<v-col cols="12" sm="6" class="text-left">
						<!-- <v-img 
							alt="logo"
							class="mb-8"
							:src="require('@/assets/logo_big.png')"
							width="120"
							contain>
						</v-img> -->
						<div>str. Calea Iesilor, 55</div>
						<div>Chisinau, Moldova</div>
					
						<div>{{'Serghei Tkachenko' | localize }}: +373 (69) 21 20 81</div>
						<div>{{'Nataliya Zharko' | localize }}: +373 (78) 80 98 33 </div>

						<v-btn dark fab small
							color="secondary" 
							class="my-8"
							target="_blank" 
							href="https://www.facebook.com/smartBusinessLearning">
							<v-icon>mdi-facebook</v-icon>
						</v-btn>
						
						
					</v-col>
					<v-col cols="12" sm="6">
						<v-form v-model="valid" ref="contactsform" lazy-validation>
							<v-text-field dense 
								v-model="firstName" 
								:label="'First name' | localize" 
								:rules="[rules.required]" 
								outlined>
							</v-text-field>
							<v-text-field dense 
								v-model="lastName" 
								:label="'Last name' | localize" 
								:rules="[rules.required]" 
								outlined>
							</v-text-field>
							<v-text-field dense 
								v-model="email" 
								:label="'Email' | localize" 
								outlined 
								:rules="[rules.required, rules.email]">
							</v-text-field>
						
							<v-textarea dense 
								v-model="textarea" 
								:label="'comments' | localize" 
								outlined 
								:rules="[rules.required]">
							</v-textarea>
						
							<v-btn color="primary" 
								class="ml-auto text-lowercase" 
								outlined :loading="loading" 
								:disabled="!valid || loading"
								@click="onSubmit()">
								{{'confirm' | localize }}
							</v-btn>
						</v-form>
					</v-col>
				</v-row>
			</v-container>
		</div>
		<v-row v-else justify="center">
			<loader></loader>
		</v-row>
	</v-container>
</template>
<script>
	import emailjs from '@emailjs/browser';
	import configEmailjs from '../config/emailJS';
	import Loader from '../layouts/Loader.vue'
	import localizeFilter from '../filters/localize.filter';


	export default {
		data () {
			return {
				firstName: '',
				email: '',
				lastName: '',
				textarea: '',
				valid: false,
				error: '',
				rules: {
					required: value => !!value || localizeFilter('required field'),
					email: value => {
						const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
						return pattern.test(value) || localizeFilter('invalid e-mail')
					}
				}
			}
		},
		computed: {
			loading() {
				return this.$store.getters.loading;
			},
			locale() {
				return this.$store.getters.locale;
			}
		},
	methods: {
		async onSubmit() {
			const msg = {}

			if (this.$refs.contactsform.validate()) {
				msg.firstName = this.firstName
				msg.email = this.email
				msg.lastName = this.lastName
				msg.message = this.textarea
			}

			try {
				emailjs.init(configEmailjs.userId);
				const result = await emailjs.send(configEmailjs.serviceId, configEmailjs.templateId, msg);

				if (result.text === 'OK') {
					this.$store.dispatch('setError', 'Thank you for your message. We will respond as soon as possible');
					this.$refs['contactsform'].reset();
				}
			}
			catch (error) {
				this.$store.dispatch('setError', 'Your message has not been delivered. Please contact us another way')
			}
		}
	},
		components: { Loader}
	}	
</script>